import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './cycleCounts.html'
//import FileSaver from 'file-saver';

/**
 * CycleCounts Report route
 *
 * @namespace routes.ReportCycleCounts
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.cycleCount.list',
  label: 'REPORT.CYCLECOUNT.TITLE',
  url: '/cycleCounts',
  component: 'tmrReportCycleCounts',
  weight: 16,
  resourceType: 'CycleCount',
  resourceList: {
    searchParameters: ['closed.to', 'closed.from', 'closed'],
  },
  accessControl: ['Resource.list', 'Resource.CycleCount.list'],
}

/**
 * Component for {@link routes.tmrReportCycleCounts CycleCounts Report route}
 *
 * @type {ngComponent}
 */
export const tmrReportCycleCounts = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportCycleCountController',
  bindings: resourceListBindings(),
}

/**
 * Controller of component {@link tmrReportCycleCounts}.
 *
 * @type {ngController}
 */
export class tmrReportCycleCountController {
  static ngType = 'controller'
  constructor(
    tmrDefaultExportFormat,
    CycleCount,
    CycleCountItem,
    TmrFile,
    TmrApi
  ) {
    'ngInject'
    Object.assign(this, {
      tmrDefaultExportFormat,
      CycleCount,
      CycleCountItem,
      TmrFile,
      TmrApi,
    })
  }

  export(id) {
    let req = this.TmrApi.get('CycleCountItem.aggregatedExport', { id: id })
    this.TmrFile.download(
      req,
      `export.${this.tmrDefaultExportFormat}`,
      null,
      true
    ).catch(err => {
      throw new Error(err.data)
    })
  }
}
